import { AppLightTooltip, AppUseIcon } from 'components/ui';
import { useCallback, useEffect, useState } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

const AppCopyText = ({ text, dataTest = 'copyButton', className = '' }: { text?: string; dataTest?: string; className?: string }) => {
  const [valueToCopy, setValueToCopy] = useState<string>('');
  const [isValueCopied, setIsValueCopied] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isValueCopied) {
      setTimeout(() => {
        setValueToCopy(valueToCopy);
        setIsValueCopied(false);
      }, 1050);
    }
  }, [isValueCopied]);

  const handleCopy = useCallback(() => {
    if (!text) return;
    setIsValueCopied(true);
    setValueToCopy(text);
  }, [text]);

  return (
    <>
      {text && (
        <AppLightTooltip className='tooltip_icon' title={`${isValueCopied ? t('copied') : t('copy')}`} placement='top'>
          <CopyToClipboard text={text} onCopy={handleCopy}>
            <button
              data-test={dataTest}
              className={`btn btn-transparent p-0 d-flex align-items-center justify-content-center ml-2 ${className}`}
              onClick={(e) => e?.stopPropagation()}
            >
              {isValueCopied ? <CheckIcon className='font-18' /> : <AppUseIcon name='CopyIcon' width='17' height='16' />}
              <span className='sr-only'>{isValueCopied ? t('copied') : t('copy')}</span>
            </button>
          </CopyToClipboard>
        </AppLightTooltip>
      )}
    </>
  );
};

export default AppCopyText;
